<template>
  <div
    class="flex relative flex-col grow basis-0 gap-3 mt-10 lg:mt-0 max-w-[800px] justify-center lg:after:content-['']"
    :class="{
      'lg:after:block lg:after:absolute lg:after:h-full lg:after:w-[2px] after:-left-8 after:bg-neutral-300 dark:after:bg-cardinal':
        showDivider,
    }"
  >
    <template v-if="yearAvailable">
      <HeadingBasic class="text-neutral-950 dark:text-white" :size="4">
        {{ sectionTitle }}
      </HeadingBasic>
      <DataBar
        v-for="(bar, index) in data"
        :key="index"
        :label="bar.label"
        :max="100"
        v-model="bar.value"
        :raw-value="bar.rawValue"
      />
    </template>
    <template v-else>
      <div
        class="flex items-center justify-center min-h-[200px] h-full text-neutral-900 dark:text-white text-lg"
      >
        <template v-if="restricted">
          <div class="flex flex-col items-center justify-center gap-3">
            <i class="fad fa-lock fa-2x mr-2 text-cardinal dark:text-cardinal-500"></i>
            <p class="font-bold">Sign up to view percentile ranking graphs</p>
            <UButton
              class="!bg-cardinal !text-white"
              :to="{ path: '/sign-up' }"
              label="Sign Up for Access"
            />
          </div>
        </template>
        <template v-else>
          <i class="far fa-search mr-2 text-cardinal dark:text-cardinal-500"></i>
          <p>
            There are no {{ sectionTitle.toLowerCase() }} rankings from {{ year }} for this
            {{ type }}.
          </p>
        </template>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
// Define props for this component
const props = defineProps<{
  sectionTitle: string;
  data: Array<{ label: string; value: number; rawValue: string }>;
  yearAvailable: boolean;
  isLastSection?: boolean;
  showDivider?: boolean;
  year?: number;
  type: 'player' | 'team';
  restricted?: boolean;
}>();

// You can include additional setup logic, methods, computed properties, or watchers as needed
</script>

<style scoped>
/* Add any specific styles for this component here */
</style>
